
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#F07300"}}),_c('path',{attrs:{"d":"M12.738 20.65h1.084v1.905h-1.084v2.263H10.27v-2.263H6.146L6 21.045l4.27-6.87v-.021h2.468v6.496zm-4.387 0h1.919v-3.28l-.154.248-1.765 3.032zM22.311 20.46c0 1.44-.325 2.551-.974 3.332-.645.782-1.555 1.172-2.732 1.172-1.186 0-2.105-.393-2.754-1.179-.65-.786-.974-1.894-.974-3.325v-1.948c0-1.44.322-2.552.967-3.333.65-.781 1.565-1.172 2.746-1.172 1.182 0 2.098.393 2.747 1.18.65.786.974 1.897.974 3.332v1.941zm-2.468-2.263c0-.767-.1-1.338-.3-1.714-.2-.38-.518-.571-.953-.571-.424 0-.735.175-.93.527-.19.352-.293.884-.308 1.597v2.724c0 .796.1 1.38.3 1.75.201.367.518.55.953.55.42 0 .73-.178.93-.535.2-.36.303-.925.308-1.691v-2.637zM25.849 18.453h1.164c.923 0 1.384-.451 1.384-1.355 0-.351-.11-.637-.33-.857-.219-.224-.529-.337-.93-.337-.326 0-.612.095-.856.286-.24.19-.36.427-.36.71h-2.467c0-.561.156-1.062.468-1.501.313-.44.745-.781 1.297-1.025a4.433 4.433 0 011.83-.374c1.187 0 2.12.271 2.799.813.678.542 1.018 1.287 1.018 2.234 0 .459-.142.893-.425 1.304-.278.405-.686.734-1.223.988.566.205 1.01.518 1.333.938.322.415.483.93.483 1.545 0 .952-.366 1.714-1.098 2.285-.733.572-1.695.857-2.886.857a4.792 4.792 0 01-1.948-.395c-.596-.269-1.048-.637-1.355-1.106a2.893 2.893 0 01-.462-1.611h2.483c0 .327.132.61.396.85.263.238.588.358.974.358.434 0 .78-.12 1.04-.359.258-.244.388-.554.388-.93 0-.537-.134-.918-.403-1.143-.268-.224-.64-.337-1.113-.337h-1.201v-1.838z","fill":"#fff"}})])
          )
        }
      }
    